<template>
    <div class="keyframe-details">
        <div v-if="bObject.isMotionObject()" class="left-align">
            <div class="pitem left right small-width-10 section inline">Key Frame</div> 
            <at-button class="pitem left right small-width-10 brandColor borderColor" type="primary" 
            icon="icon-plus" @click="addKeyFrame">Add</at-button>
            <at-button class="pitem left right small-width-10 brandColor borderColor" type="primary" 
            icon="icon-minus" @click="removeKeyFrame">Remove</at-button>
        </div> 
    </div>
</template>
<script>
import { BMotionObject } from '../../lib/bezieLib/Objects/BMotionObject';
import { BObject } from '../../lib/bezieLib/Objects/BObject';
import { Scene } from '../../lib/bezieLib/Scene';

export default {
  name: 'KeyFrameDetails',
  props: {
    bObject : BObject, 
    bScene : Scene
  },
  data: function(){
    return {
    }
  },
  methods: {
    addKeyFrame(){
        this.bObject.addKeyFrame();
    },
    removeKeyFrame(){
        console.log("will remove keyframe");
    }
  }
}
</script>

<style scoped>

</style>